import { DefaultTheme, ThemeProps } from 'styled-components';
import { getSpacingToken, getToken, Sized } from '@optimus-web/common';
import { SupplementaryIconVariant } from '../SupplementaryIcon';
import { IconVariant } from './types';

export const getIconSize = (props: Required<Sized> & ThemeProps<DefaultTheme>) => {
    const { size, theme } = props;

    switch (size) {
        case 'small':
            return getSpacingToken('200')({ theme });
        case 'medium':
            return getSpacingToken('300')({ theme });
        case 'large':
        case 'extraLarge':
            return getSpacingToken('400')({ theme });
    }
};

export const getIconColor = (
    props: ThemeProps<DefaultTheme> & { variant?: IconVariant | SupplementaryIconVariant }
) => {
    if (props.variant === 'danger') {
        return getToken('textAlertDanger');
    } else if (props.variant === 'info') {
        return getToken('textAlertInfo');
    } else if (props.variant === 'inverse') {
        return getToken('textStaticInverse');
    } else if (props.variant === 'primary') {
        return getToken('textInteractivePrimaryDefault');
    } else if (props.variant === 'success') {
        return getToken('textAlertSuccess');
    } else if (props.variant === 'warning') {
        return getToken('textAlertWarning');
    } else if (props.variant === 'basic') {
        return getToken('textStaticPrimary');
    } else if (props.variant === 'inherit') {
        return 'currentColor';
    }
};
